<template>
  <nav class="navbar navbar-expand-lg  navbar-dark old_style_nav fixed-top">
    <div class="collapse navbar-collapse" id="navbarSupportedContent" style="margin: 0 0 0 15mm;">
          <ul class="navbar-nav mr-auto">
     <!--        <li class="nav-item old_style_nav_item">
              <router-link :to="'/documents/'+$route.params.id"  class="nav-link  old_style_nav_link" exact-active-class="active">Спецификация</router-link>
            </li>
            <li class="nav-item old_style_nav_item">
              <router-link no-prefetch :to="'/documents/contract/'+$route.params.id" class="nav-link  old_style_nav_link"  exact-active-class="active">Договор</router-link>
            </li>      
            <li class="nav-item old_style_nav_item">
              <router-link no-prefetch :to="'/documents/invoice/'+$route.params.id" class="nav-link  old_style_nav_link"  exact-active-class="active">Счёт</router-link> 
            </li>
            <li v-if="$root.user.supervisor" class="nav-item old_style_nav_item">
              <router-link no-prefetch :to="'/documents/act/'+$route.params.id"  class="nav-link  old_style_nav_link"  exact-active-class="active">Акт</router-link> 
            </li> -->
              <li v-if="$root.user.supervisor" class="nav-item old_style_nav_item">
              <router-link no-prefetch :to="'/documents/search'"  class="nav-link  old_style_nav_link"  exact-active-class="active">Поиск документов</router-link> 
            </li>
              <li class="nav-item old_style_nav_item">
              <router-link no-prefetch :to="'/documents/'+$root.invoice_id"  class="nav-link  old_style_nav_link"  exact-active-class="active">{{ $root.sublicentiate.short_name }}</router-link> 
            </li>  
          </ul>
    </div>
</nav>
</template>


<style type="text/css">

    .old_style_nav{
        background: linear-gradient(-90deg,  #155774, #2495bc);
            -webkit-background-size: cover;
            -moz-background-size: cover;
            -o-background-size: cover;
            background-size: cover;
            opacity: 0.9;
    }

    .old_style_nav_link{
        text-decoration: none !important;

    }

    .old_style_nav_item{
        margin: 0 8px 0 8px;
    }

    .old_style_nav_phone{
        text-decoration: none !important;
        color: #fff;
        pointer-events: none;
        font-size: 18px;
    }

    .special_offer_link{
        
    }

</style>

